// Template creation inputs (prompt: generic template inputs and live preview).
//
// A reusable template asks for a small number of template-specific facts before a
// draft is generated. These input definitions and the values entered for one new
// Change are deliberately separate from the reusable template structure: the
// template holds `{{input:...}}` placeholders, the input values hold the facts.

// The control a single creation input renders. Intentionally narrow for the MVP.
export const TEMPLATE_CREATION_INPUT_TYPE = {
  SHORT_TEXT: 'shortText',
  LONG_TEXT: 'longText',
  SINGLE_CHOICE: 'singleChoice',
  PRODUCT_REFERENCE: 'productReference',
  PRODUCT_MULTI_REFERENCE: 'productMultiReference',
} as const;
export type TTemplateCreationInputType =
  (typeof TEMPLATE_CREATION_INPUT_TYPE)[keyof typeof TEMPLATE_CREATION_INPUT_TYPE];

// An entity picked as a template input (e.g. a product). Text generation uses the
// label; the id lets the created Change reference the real entity later.
export type TTemplateEntityReference = {
  id: string;
  label: string;
};

// The value entered for one creation input. `null` means "not yet provided".
export type TTemplateInputValue = string | string[] | TTemplateEntityReference | TTemplateEntityReference[] | null;

export type TTemplateCreationInputConfig = {
  id: string;
  label: string;
  fieldType: TTemplateCreationInputType;
  required: boolean;
  placeholder?: string;
  helpText?: string;
  options?: string[];
};

// The immutable record of the facts a template was instantiated with. Stored on
// the created Change so later edits to the organization template never mutate it.
export type TInstantiatedTemplateSnapshot = {
  templateId: string;
  templateVersion: number;
  inputValues: Record<string, TTemplateInputValue>;
  instantiatedAt: string;
};
